import { render } from "./TheMbLinkCollection.vue?vue&type=template&id=6b95a3b1&scoped=true"
import script from "./TheMbLinkCollection.vue?vue&type=script&lang=js"
export * from "./TheMbLinkCollection.vue?vue&type=script&lang=js"

import "./TheMbLinkCollection.vue?vue&type=style&index=0&id=6b95a3b1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6b95a3b1"

export default script